import { useLinkProps, useLocation, useParams } from '@tanstack/react-router';
import { startCase } from 'lodash';
import type { FC } from 'react';
import Tab from 'src/components/0200_tab';
import ResponsiveTabGroup from 'src/components/0300_responsive_tabs_group';
import usePermission from 'src/hooks/permissions/usePermissions';

const MechanicsHeader: FC = () => {
  const { organizationSlug } = useParams({ strict: false });
  const { pathname } = useLocation();
  const isMechanicsRoute = pathname.includes('mechanics');
  const section = pathname.match(
    /(diseases|societies|threats|faiths|dice_roller)/,
  )?.[0];
  const { isPermitted } = usePermission({
    action: 'manage_fellowships',
  });
  const linkToDiceRoller = useLinkProps({
    to: '/$organizationSlug/mechanics/dice_roller',
    params: { organizationSlug: String(organizationSlug) },
  });
  const linkToDiseases = useLinkProps({
    to: '/$organizationSlug/mechanics/diseases/$',
    params: { organizationSlug: String(organizationSlug), _splat: '' },
  });
  const linkToFaiths = useLinkProps({
    to: '/$organizationSlug/mechanics/faiths/$',
    params: { organizationSlug: String(organizationSlug), _splat: '' },
  });
  const linkToSocieties = useLinkProps({
    to: '/$organizationSlug/mechanics/societies/$',
    params: { organizationSlug: String(organizationSlug), _splat: '' },
  });
  const linkToThreats = useLinkProps({
    to: '/$organizationSlug/mechanics/threats/$',
    params: { organizationSlug: String(organizationSlug), _splat: '' },
  });

  if (!isPermitted) return null;
  if (!organizationSlug || !isMechanicsRoute) return null;

  return (
    <ResponsiveTabGroup label={startCase(section) || 'Diseases'}>
      <Tab
        label="Dice Roller"
        to={linkToDiceRoller.href}
        highlightMode="responsive"
        isActive={section === 'dice_roller'}
      />
      <Tab
        label="Diseases"
        to={linkToDiseases.href}
        highlightMode="responsive"
        isActive={section === 'diseases' || !section}
      />
      <Tab
        label="Faiths"
        to={linkToFaiths.href}
        highlightMode="responsive"
        isActive={section === 'faiths'}
      />
      <Tab
        label="Societies"
        to={linkToSocieties.href}
        highlightMode="responsive"
        isActive={section === 'societies'}
      />
      <Tab
        label="Threats"
        to={linkToThreats.href}
        highlightMode="responsive"
        isActive={section === 'threats'}
      />
    </ResponsiveTabGroup>
  );
};

export default MechanicsHeader;
